<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'ModuleCodesBulk',
  computed: {
    ...mapState('course/collection', {
      courses: 'items',
    }),
    ...mapState('tag/collection', {
      tags: 'items',
    }),
    ...mapState('code/bulk', [
      'item',
    ]),
    course: {
      get () {
        return this.item.course || '';
      },
      set (value) {
        const { item } = this;
        item.course = value;
        this.setItem(item);
      },
    },
    tag: {
      get () {
        return this.item.tag || '';
      },
      set (value) {
        const { item } = this;
        item.tag = value;
        this.setItem(item);
      },
    },
    amount: {
      get () {
        return this.item.amount;
      },
      set (value) {
        const { item } = this;
        item.amount = value;
        this.setItem(item);
      },
    },
    days: {
      get () {
        return this.item.days;
      },
      set (value) {
        const { item } = this;
        item.days = value;
        this.setItem(item);
      },
    },
    codes: {
      get() {
        return this.item.codes.join('\n');
      },
      set(value) {
        const { item } = this;
        item.codes = value.split('\n');
        this.setItem(item);
      },
    },
  },
  methods: {
    ...mapActions('course/collection', {
      fetchCourses: 'fetch',
    }),
    ...mapActions('tag/collection', {
      fetchTags: 'fetch',
    }),
    ...mapActions('code/bulk', [
      'create',
    ]),
    ...mapMutations('code/bulk', [
      'setItem',
      'reset',
    ]),
    localCreate () {
      this.create()
        .then(() => {
          this.$router.push({ name: 'codes-listing' });
        })
      ;
    },
  },
  created() {
    this.fetchCourses(false);
    this.fetchTags();
  },
};
</script>
<template>
  <div class="box">
    <h2>General</h2>
    <div class="form-group mt-3">
      <label for="course" class="d-block">Course</label>
      <select id="course" class="form-control rounded-0" v-model="course">
        <option value="" disabled>Select a Course</option>
        <option v-for="course in courses" :key="course.id" :value="course.id">{{ course.title }}</option>
      </select>
    </div>
    <div class="form-group mt-3">
      <label for="tag" class="d-block">Tag</label>
      <select id="tag" class="form-control rounded-0" v-model="tag">
        <option value="" disabled>Select a Tag</option>
        <option v-for="tag in tags" :key="tag.id" :value="tag.id">{{ tag.name }}</option>
      </select>
    </div>
    <div class="form-group mt-3">
      <label for="amount" class="d-block">Amount of Codes to Generate</label>
      <input id="amount" class="form-control rounded-0" v-model="amount" />
    </div>
    <div class="form-group mt-3">
      <label for="days" class="d-block">Days</label>
      <input id="days" class="form-control rounded-0" v-model="days" />
    </div>
    <div class="form-group mt-3">
      <label for="codes" class="d-block">Codes</label>
      <small class="d-block">One code per line</small>
      <small class="d-block">
        You can combine this with "Amount" field above; if add 50 in amount and add 10 codes here, it will generate 60 codes in total.
        <br />
        Given if no duplicates will be created; If you added code 123456 and auto generation created 123456, it will create 59 codes in total.
      </small>
      <textarea id="codes" class="form-control rounded-0" v-model="codes"></textarea>
    </div>
    <div class="form-group mt-3 text-right">
      <button class="btn btn-primary" @click="localCreate">Generate</button>
    </div>
  </div>
</template>
